<template>
  <div>
    <div v-if="$store.getters.get_all_user.id !== 1">
      <div class="" v-if="$store.getters.get_campu == null || $store.getters.get_rol == null">
        <CRow v-if="$store.getters.get_campu == null">
          <CampusVue :campus="cpCam" :logo="logo" @mtdSetCampu="mtdSetCampu" />
        </CRow>
        <CRow v-else>
          <RolVue :roles="roles" @mtdSetRol="mtdSetRol" />
        </CRow>
      </div>
      <div v-else>
        <AdministradorVue v-if="$store.getters.get_rol.id == 4" />
        <BarberVieeVue
          v-if="$store.getters.get_rol.id !== 1 && $store.getters.get_rol.id !== 2 && $store.getters.get_rol.id !== 4" />
        <RecepcionistVue v-if="$store.getters.get_rol.id == 2" />
      </div>
    </div>
    <div v-else>
      <div v-if="$store.getters.get_rol == null">
        <RolVue :roles="roles" @mtdSetRol="mtdSetRol" />
      </div>
      <div v-else>
        <AdministradorHowertVue />
      </div>
    </div>
  </div>
</template>

<script>
import CampusVue from '../components/home/Campus.vue';
import RolVue from '../components/home/Rol.vue';

import AdministradorVue from '../views/administrador/index.vue';
import BarberVieeVue from './Barber/BarberViee.vue';
import AdministradorHowertVue from './administradorHowert/index.vue';
import RecepcionistVue from './receptionist/index.vue';
import { mapActions } from "vuex";


export default {
  name: 'Dashboard',
  components: { CampusVue, RolVue, AdministradorVue, BarberVieeVue, AdministradorHowertVue, RecepcionistVue },
  data() {
    return {
      roles: [],
      rol: null,
      campus: [],
      logo: null,
    }
  },
  computed: {
    cpCam() {
      return this.$store.getters.get_campus;
    }
  },
  created() {
    this.$store.getters.get_all_user.roles.forEach(element => {
      this.roles.push(element.role);
    });
    this.logo = this.$store.getters.get_all_user.id == 1 ? null : this.$store.getters.get_company.logo;
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdSetRol: function (payload) {
      this.$store.commit("mt_set_rol", payload);
    },
    mtdSetCampu: function (payload) {
      this.$store.commit("mt_set_campu", payload);
    },
    mtdSetRol2: function () {
      this.$emit("mtdSetRol", this.$store.getters.get_all_user.roles[0].role);
    },
    mtdWspSend() {
      if (this.$store.getters.get_company.id == 10) {        
        this.post({
          url: this.$store.getters.get__url + "/whatsapp/send",
          token: this.$store.getters.get__token,
        })
          .then((response) => {
            // console.log(response);
          })
          .catch((erros) => {
            // this.errorsBackend = errors;
            // this.$emit("error", this.event);
          });
      }
    }
  }
}
</script>
